export const LEFT = 'left';
export const RIGHT = 'right';
export const UP = 'up';
export const DOWN = 'down';
export const PLAYER_SPEED = 10;
export const PLAYER_UPDATE_SPEED = 10;
export const CANVAS_WIDTH = 1500;
export const CANVAS_HEIGHT = 900;
export const PLAYER_WIDTH = 30;
export const CELL_WIDTH = PLAYER_WIDTH * 5;
export const CELLS_HORIZONTALLY_ON_CANVAS = CANVAS_WIDTH / CELL_WIDTH;
export const CELLS_VERTICALLY_ON_CANVAS = CANVAS_HEIGHT / CELL_WIDTH;
